import { useEffect, useState } from 'react'
import type { ProjectGoldFactRow } from '../types/projectAnalysis'

export function useProjectGoldFact(projectId: number | null) {
  const [data, setData] = useState<ProjectGoldFactRow[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (projectId == null || Number.isNaN(projectId)) {
      setData([])
      setLoading(false)
      setError(null)
      return
    }
    let cancelled = false
    setLoading(true)
    setError(null)
    fetch(
      `/ts_project_json/gold_fact_project_user_monthly_project_id_${projectId}.json`,
    )
      .then((r) => {
        if (!r.ok) throw new Error('Project data not found')
        return r.json() as Promise<unknown>
      })
      .then((arr) => {
        if (!cancelled) setData(Array.isArray(arr) ? arr : [])
      })
      .catch((err: Error) => {
        if (!cancelled) setError(err.message || 'Failed to load project data')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })
    return () => {
      cancelled = true
    }
  }, [projectId])

  return { data, loading, error }
}
